import { PeopleApi } from 'api'
import { Model } from 'api'
import { Formatter } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { Multiselect } from 'multiselect-react-dropdown';
import { SeatsioSeatingChart } from '@seatsio/seatsio-react/src/main';
import { useState } from 'react';

const driveQueryVariable = value => {
  let stringifyValue = '';
  delete value['fran_amount']
  let keys = Object.keys(value)
  keys.forEach((key, index) => {
    stringifyValue = stringifyValue + `${key}:${value[key]}${index == keys.length - 1 ? '': '-'}`
  })
  return stringifyValue;
}
const EventReservationBlock = (props) => {
  // Consts
  let { base, event, subroute } = props
  let defaultTicketTypeName = event.defaultTicketType && event.defaultTicketType.id

  // State
  window.fran_success_location = `${props.base}/${props.event.uid}`
  const [tickets, setTickets] = useState(props.event.event_id ? { } :{ [defaultTicketTypeName]: (props.event.isFamily ? 0 : 1) })
  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState([])
  const [selectedSeats, setSelectedSeats] = useState({})

  // Consts
  let linkedUsersJson = PeopleApi.kick('linked_users', {})
  const seatingChartPricing = event.ticket_settings.map(setting => ({
    category: setting.type,
    price: setting.amount ? setting.amount/100 : 0
  }));
  const showSeatDetails = event.category === 'seated';
  // Calculate total price for each category
  const seatCategories = Object.keys(selectedSeats).map(category => {
    const seatCount = selectedSeats[category].length;
    const seatPriceCents = event.ticket_settings.find(setting => setting.type === category)?.amount || 0;
    const seatPriceDollars = seatPriceCents / 100;  // Convert price from cents to dollars
    const totalPrice = seatPriceDollars * seatCount;
    return { category, seats: selectedSeats[category], seatCount, totalPrice };
  });
  const subtotal = seatCategories.reduce((sum, category) => sum + category.totalPrice, 0);
  const selectedOccurrenceId = Model.extractSubrouteArgs(subroute, 0) || event.hasReservableOccurrences && event.reservableOccurrences[0].id

  // Hooks

  // Custom Methods
  const inc = (ticketTypeName, count) => {
    setTickets({ ...tickets, [ticketTypeName]: (tickets[ticketTypeName] || 0) + count })
  }

  const occurrenceSelected = (e) => {
    let { event, base } = props
    application.go(`${base}/${event.uid}::reserve:${e.target.value}`)
  }

  const onSeatDeselected = (seat) => {
    // Decrement the ticket count for the deselected seat's category, ensuring it doesn't go below 0
    if (tickets[seat.category.label] > 0) {
      tickets[seat.category.label] -= 1;

      // If the count becomes zero, remove the ticket category from the tickets object
      if (tickets[seat.category.label] === 0) {
        delete tickets[seat.category.label];
      }
    }

    // Remove the deselected seat from the correct category in selectedSeats
    selectedSeats[seat.category.label] = selectedSeats[seat.category.label].filter(selectedSeat => selectedSeat !== seat.seatId);

    // If no seats remain in this category, remove the category from selectedSeats
    if (selectedSeats[seat.category.label].length === 0) {
      delete selectedSeats[seat.category.label];
    }
    setTickets(tickets)
    setSelectedSeats(selectedSeats)
  }

  const onSeatSelected = (seat) => {
    // Increment the ticket count for the selected seat's category
    tickets[seat.category.label] = (tickets[seat.category.label] || 0) + 1;

    selectedSeats[seat.category.label] = [...(selectedSeats[seat.category.label] || []), seat.seatId];
    setTickets(tickets)
    setSelectedSeats(selectedSeats)
  }

  const onRemove = (selectedList, _removedItem) => {
    setSelectedFamilyMembers(selectedList.map(({id}) => ({ id })))
  }

  const onSelect = (selectedList, _selectedItem) => {
    setSelectedFamilyMembers(selectedList.map(r => r.id))
  }

  const renderCardRequired = () => {
    return <div className="EventReservation-card-required">
      <p>You need to set up a credit card to reserve events.</p>
      <Link to="/settings/payment">Add a Credit Card</Link>
    </div>
  }

  const reserve = async () => {
    let { event, base, reloadSmartButtons } = props

    // If there are selected seats, set tickets to an empty array
    if (selectedSeats && selectedSeats.length > 0) {
        tickets = []  // Send empty array in tickets when there are selected seats
    }

    // Pass the selected seats to the reservation method
    let result = await event.reserve(selectedOccurrenceId || event.id, tickets, selectedFamilyMembers, selectedSeats)
    if (result) {
      application.go(`${base}/${event.uid}`)
      reloadSmartButtons()
    }
  }

  const reserveFran = async () => {
    let { reloadSmartButtons } = props
    let fran = {'fran_amount': true}
    let data = Object.assign(tickets, fran);
    let eventOrOccuurrence = selectedOccurrenceId || event.id
    let result = await event.reserve(eventOrOccuurrence, data, selectedFamilyMembers)
    if (result) {
      application.go(`/settings/payments/event:${eventOrOccuurrence}/${result.fran_amount}/${driveQueryVariable(tickets)}`)
      reloadSmartButtons()
    }
  }

  if (event.requiresPayment && !application.user.hasCard && document.getElementById('square-js')) return renderCardRequired()

  if (event.requiresPayment && !application.user.hasCard) return renderCardRequired()

  return (
    <div className="EventReservation-form">
      <h3 className="EventReservation-heading">Reservation Details</h3>
      {showSeatDetails && event.event_id &&
        <div style={{ 'height': '500px' }}>
          <SeatsioSeatingChart
            workspaceKey={event.workspace_key}
            event={event.event_id}
            region="na"
            onObjectSelected={onSeatSelected}     // Add seat selection handler
            onObjectDeselected={onSeatDeselected} // Add seat deselection handler
            pricing={seatingChartPricing}
            showLegend={true}  // Show/hide legend if needed
            showFullScreenButton={false}
            priceFormatter= {function(price) {
                return '$' + price;
            }}
          />
        </div>
      }
      {showSeatDetails &&  event.event_id && (
        <div className="EventReservation-selected-seats-summary">
          <h4 className="EventReservation-selected-seats-summary-title">Selected Seats</h4>

          {seatCategories.length > 0 ? (
            <ul className="seat-list">
              {seatCategories.map((seat, index) => (
                <li key={index} className="seat-item">
                  <span className="seat-number">{seat.category} : {seat.seats.join(', ')}</span>
                  {seat.totalPrice > 0 && <span className="seat-price">Price: ${seat.totalPrice.toFixed(2)}</span>}
                </li>
              ))}
            </ul>
          ) : (
            <p className="EventReservation-selected-seats-summary-no-seats-selected">No seats selected.</p>
          )}

          <div className="EventReservation-selected-seats-summary-total-summary">
            <span className="total-label">Total:</span>
            <span className="total-amount">
            ${subtotal.toFixed(2)}
            </span>
          </div>
        </div>
      )}
      {event.hasReservableOccurrences &&
        <div className="EventReservation-occurrences">
          <select className='form-control' onChange={occurrenceSelected} value={selectedOccurrenceId}>
            {event.reservableOccurrences.map(occurrence =>
              <option value={occurrence.id} key={occurrence.id}>{occurrence.displayName}</option>
            )}
          </select>
        </div>

      }
      <div className="EventReservation-ticket-types">
        <table className="table">
          <tbody>
          { !showSeatDetails && !event.isFamily && !event.event_id &&
            event.ticket_settings && event.ticket_settings.map(ticketSetting =>
              <tr key={ticketSetting.type}>
                <td style={{ width: '37%' }}>{ticketSetting.type}</td>
                <td>{Formatter.amountFromCents(ticketSetting.amount)}</td>
                <td className="text-right">
                  <button type='button' className='btn btn-outline-primary btn-sm ticket-btn' onClick={() => inc(ticketSetting.id, -1)}>–</button>
                  <span className='counter'>{tickets[ticketSetting.id] || 0}</span>
                  <button type='button' className='btn btn-outline-primary btn-sm ticket-btn' onClick={() => inc(ticketSetting.id, +1)}>+</button>
                </td>
              </tr>
            )
          }
            { event.isFamily &&
              <tr>
                <td colSpan="3">
                  <h6>Select Family Profile</h6>
                  <Multiselect
                    options={linkedUsersJson}
                    onSelect={onSelect}
                    onRemove={onRemove}
                    displayValue="name"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div className="EventReservation-action">
        {
          document.getElementById('fran-js') && event.requiresPayment ? <SmartButtonStub text={event.btn_text || "Reserve"} click={reserveFran} /> : <SmartButtonStub text={event.btn_text || "Reserve"} click={reserve} />
        }
        <Link to={`${base}/${event.uid}`} className='btn smart-button'>Cancel</Link>
      </div>
    </div>
  )
}

export default EventReservationBlock
